import classNames from "classnames";
import React, { FC } from "react";
import styles from "./Button.module.css";

type TExitBtnprops = {
  userIsSubscribed?: boolean,
  handleIsOpenChange: (bool: boolean) => void,
  style: { [key: string]: string }
}

export const ExitBtn: FC<TExitBtnprops> = ({
  userIsSubscribed,
  style,
  handleIsOpenChange }) => {

  return (
    <>
      <button
        style={{ ...style }}
        className={classNames(styles.exitBtn, "modal-exit-button")}
        onClick={() => handleIsOpenChange(false)}>
        <p>X</p>
      </button>
    </>
  );
};
